module.exports = __webpack_public_path__ + "img/Wood-Panel-Boards.525e9ddd.jpg";